import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "mobile-region-wrap"
};
const _hoisted_2 = {
  class: "mobile-region-modal"
};
const _hoisted_3 = {
  class: "mobile-region-grid"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "mobile-region-all-wrap"
};
const _hoisted_6 = {
  class: "region-bar-gradient"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["onClick", "onMouseenter", "onMouseleave"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [$data.isMobileView ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("button", {
    type: "button",
    class: "mobile-region-btn",
    onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => $options.openRegionModal && $options.openRegionModal(...args), ["stop"]))
  }, _toDisplayString($data.currentRegionLabel), 1), _withDirectives(_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "mobile-region-mask",
    onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => $options.closeRegionModal && $options.closeRegionModal(...args), ["stop"]))
  }), _createElementVNode("div", {
    class: "mobile-region-panel",
    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
  }, [_createElementVNode("button", {
    type: "button",
    class: "mobile-region-close",
    "aria-label": "关闭",
    onClick: _cache[2] || (_cache[2] = _withModifiers((...args) => $options.closeRegionModal && $options.closeRegionModal(...args), ["stop"]))
  }), _createElementVNode("ul", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$attrs.typelist, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index,
      class: _normalizeClass(["mobile-region-item", {
        active: $data.typeIndex === index + 1
      }]),
      onClick: $event => $options.selectRegion(item, index + 1)
    }, [_createElementVNode("span", null, _toDisplayString(item.itemformdata.title), 1)], 10, _hoisted_4);
  }), 128))]), _withDirectives(_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
    class: _normalizeClass(["mobile-region-item mobile-region-item--all", {
      active: $data.typeIndex === 0
    }]),
    onClick: _cache[3] || (_cache[3] = $event => $options.selectRegion(null, 0))
  }, [...(_cache[16] || (_cache[16] = [_createElementVNode("span", null, "新疆全区", -1)]))], 2)], 512), [[_vShow, _ctx.$attrs.showtypeall]])])], 512), [[_vShow, $options.modalVisible]])])) : _createCommentVNode("", true), !$data.isMobileView && $options.isXinjiangMap ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "region-bar-container",
    style: _normalizeStyle($options.barStyle)
  }, [_cache[17] || (_cache[17] = _createElementVNode("div", {
    class: "region-deco",
    "aria-hidden": "true"
  }, null, -1)), _createElementVNode("div", _hoisted_6, [_createElementVNode("ul", {
    class: _normalizeClass(["region-scroll-list", {
      'is-dragging': $data.regionDrag.active
    }]),
    ref: "regionScroll",
    onMousedown: _cache[6] || (_cache[6] = (...args) => $options.onRegionDragStart && $options.onRegionDragStart(...args)),
    onTouchstartPassive: _cache[7] || (_cache[7] = (...args) => $options.onRegionTouchStart && $options.onRegionTouchStart(...args)),
    onTouchmove: _cache[8] || (_cache[8] = _withModifiers((...args) => $options.onRegionTouchMove && $options.onRegionTouchMove(...args), ["prevent"])),
    onTouchend: _cache[9] || (_cache[9] = (...args) => $options.onRegionTouchEnd && $options.onRegionTouchEnd(...args)),
    onWheel: _cache[10] || (_cache[10] = _withModifiers((...args) => $options.onRegionWheel && $options.onRegionWheel(...args), ["prevent"]))
  }, [_withDirectives(_createElementVNode("li", {
    class: _normalizeClass(["region-pill", {
      active: $data.typeIndex === 0
    }]),
    onClick: _cache[5] || (_cache[5] = $event => $options.handleRegionPillClick(null, 0))
  }, _toDisplayString($data.allRegionLabel), 3), [[_vShow, _ctx.$attrs.showtypeall]]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$attrs.typelist, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index,
      class: _normalizeClass(["region-pill", {
        active: $data.typeIndex === index + 1
      }]),
      onClick: $event => $options.handleRegionPillClick(item, index + 1)
    }, _toDisplayString(item.itemformdata.title), 11, _hoisted_7);
  }), 128))], 34), _createElementVNode("button", {
    type: "button",
    class: "region-scroll-btn",
    "aria-label": "向右滚动",
    onMousedown: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"])),
    onClick: _cache[12] || (_cache[12] = (...args) => $options.scrollRegionBar && $options.scrollRegionBar(...args))
  }, null, 32)])], 4)) : !$data.isMobileView && !$options.isXinjiangMap ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [_cache[18] || (_cache[18] = _createElementVNode("div", {
    class: "star"
  }, null, -1)), _ctx.$attrs.typeshowflag === 1 && $data.isUseComp1 ? (_openBlock(), _createElementBlock("ul", {
    key: 0,
    class: _normalizeClass(["typeul", `fid${_ctx.$route.query.fid}`]),
    style: _normalizeStyle($options.barStyle)
  }, [_withDirectives(_createElementVNode("li", {
    onClick: _cache[13] || (_cache[13] = $event => $options.typeClick(null, 0)),
    class: "type-li",
    onMouseenter: _cache[14] || (_cache[14] = $event => $options.setHover(true, 0)),
    onMouseleave: _cache[15] || (_cache[15] = $event => $options.setHover(false, 0))
  }, [_createElementVNode("span", {
    class: _normalizeClass({
      city: $data.isHovered[0]
    })
  }, _toDisplayString($data.allRegionLabel), 3)], 544), [[_vShow, _ctx.$attrs.showtypeall]]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$attrs.typelist, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index,
      onClick: $event => $options.typeClick(item, index + 1),
      class: "type-li",
      onMouseenter: $event => $options.setHover(true, index + 1),
      onMouseleave: $event => $options.setHover(false, index + 1)
    }, [_createElementVNode("span", {
      class: _normalizeClass({
        city: $data.isHovered[index + 1]
      })
    }, _toDisplayString(item.itemformdata.title), 3)], 40, _hoisted_8);
  }), 128))], 6)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)]);
}